<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Helpers
	import {
		removeTariff,
		savePowerPrices,
		saveTariff,
		enableLiveTariff,
		removeLiveTariff,
	} from '../../../helpers/power_prices_helpers';
	import { capFirstChar, sortOn, wait } from '../../../helpers/utilities';
	// Design system components
	import {
		Button,
		ButtonGroup,
		CardGrid,
		AdvancedCard,
		ActionsContainer,
		IconButton,
		Icon,
		toast,
		Label,
		Modal,
		Text,
		Toggle,
		Alert,
		Container,
		DropdownMenu,
		MenuItemList,
		SelectCard,
	} from '@Shelly/shelly-design-system';
	//App Components
	import AddEditTariffWizard from './AddEditTariffWizard.svelte';
	//Types
	import type { PowerPricesData, PowerPricesTariff } from '../../../types/PowerPrices';
	import LiveTariff from './LiveTariff.svelte';
	import { user_data, user_settings } from 'src/stores/account/user';
	import { ListItem } from '@Shelly/shelly-design-system/index';
	import { SystemScreenBreakpoints } from '@Shelly/shelly-design-system/helpers/enums';
	import { afterUpdate } from 'svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let powerPrices: PowerPricesData,
		currency = '',
		disableTariffs = false;

	let showModal = false,
		removeTariffModal = false,
		maxTariffs = 6, //increased with https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2034
		editedTariff: PowerPricesTariff = null,
		waitForResponse = false,
		renewToken = false,
		showLiveTariffInfo = true,
		loading = false,
		windowInnerWidth: number,
		showModalTariffsActions = false;
	$: liveTariff = {
		...$user_settings?.power_prices_live_tariff,
		currency: currency,
	};
	const editTariff = (tarriff: PowerPricesTariff) => {
			showModal = true;
			editedTariff = { ...tarriff };
		},
		addTariff = () => {
			const tariffs = Object.keys(powerPrices.tariffs);
			if (tariffs.length <= maxTariffs) {
				let id = 0;
				for (let i = 1; i <= maxTariffs; i++) {
					if (powerPrices.tariffs[i] == null) {
						id = i;
						break;
					}
				}
				editTariff({
					id,
					name: `tariff ${id}`,
					price: 0,
					create: Date.now(),
				});
			} else {
				toast.open({
					type: 'danger',
					title: $format('tariff_limit_alert_message', {
						default: 'You have reached the limit of 5 tariffs.',
					}),
				});
			}
		},
		showDeleteTarrifsPrompt = (tariff: PowerPricesTariff) => {
			removeTariffModal = true;
			editedTariff = { ...tariff };
		},
		remove = () => {
			let toastMsg = $format('tariff_deleted_succ', {
				default: 'Tariff deleted successfully.',
			});
			setPowerPrices(removeTariff(editedTariff, powerPrices), toastMsg);
		},
		setPowerPrices = async (powerPricesData: PowerPricesData, toastMsg = '') => {
			waitForResponse = true;
			const res = await savePowerPrices(powerPricesData, true, toastMsg);
			if (res?.isok) {
				powerPrices = powerPricesData;
				showModal = false;
				removeTariffModal = false;
			}
			waitForResponse = false;
		},
		save = () => {
			let toastMsg = $format('tariff_saved_succ', {
				default: 'Tariff added successfully!',
			});
			setPowerPrices(saveTariff(editedTariff, powerPrices), toastMsg);
		},
		toggleDisableTariffs = () => {
			disableTariffs = !disableTariffs;
		},
		addRemoveLiveTariff = async () => {
			loading = true;
			if (renewToken) {
				enableLiveTariff();
				wait(1000).then(() => {
					renewToken = false;
				});
			} else {
				toggleDisableTariffs();
				if (disableTariffs) {
					await enableLiveTariff();
				} else {
					await removeLiveTariff();
				}
			}
			loading = false;
		},
		toggleTariffDropdown = (i: number) => {
			if (isNotDesktop) return;

			tariffDropdowns[i].showDropdown = !tariffDropdowns[i].showDropdown;
		},
		onCloseTariffActionsModal = () => {
			showModalTariffsActions = false;
		};

	let tariffDropdowns = Object.values(powerPrices.tariffs).map(() => ({
		showDropdown: false,
	}));

	afterUpdate(() => {
		if (Object.values(powerPrices.tariffs).length !== tariffDropdowns.length) {
			// Ivo: Recreated tariffDropdowns arr if powerPrices.tariffs length changes ( added/deleted tariff );
			tariffDropdowns = Object.values(powerPrices.tariffs).map(() => ({
				showDropdown: false,
			}));
		}
	});

	$: isNotDesktop = windowInnerWidth <= SystemScreenBreakpoints.TABLET_MAX;
</script>

<svelte:window bind:innerWidth={windowInnerWidth} />

<!-- {#if $user_data?.test_user} -->
<div class=" d-flex align-items-center mb-s">
	<Text class="mr-s" element="h2">
		{$format('title_tariff', { default: 'Tariff' })}
	</Text>
	<ButtonGroup
		id="buttongroup-959jy51"
		aria-label={$format('label_tariff_type', { default: 'Tariff type' })}
	>
		<Button
			class={!disableTariffs ? 'active' : undefined}
			size="m"
			on:click={disableTariffs ? addRemoveLiveTariff : undefined}
			{loading}
			>{$format('button_default_tariff', {
				default: 'Default',
			})}</Button
		>
		<Button
			size="m"
			class={disableTariffs ? 'active' : undefined}
			{loading}
			on:click={!disableTariffs ? addRemoveLiveTariff : undefined}
			>{$format('button_live_tariff', {
				default: 'Live',
			})}</Button
		>
	</ButtonGroup>
	<!-- <IconButton
			variant="help"
			icon="fas fa-circle-info"
			style="color:#fffaaa;"
			on:click={() => (showLiveTariffInfo = true)}
		/> -->
</div>
{#if disableTariffs && liveTariff}
	<LiveTariff bind:renewToken bind:showLiveTariffInfo on:renew={addRemoveLiveTariff} {liveTariff} />
{/if}
<!-- {:else}
		<Text element="h2" class="mb-s">
			{$format('title_tariffs', { default: 'Tariffs' })}
		</Text>
	{/if} -->
{#if !disableTariffs}
	{#if Object.keys(powerPrices.tariffs).length == 0}
		<Alert
			type="info"
			class="mb-s"
			heading={$format('add_tariff_to_link_intervals_title', {
				default: 'Add Tariffs to link to your Intervals in order to start creating Intervals.',
			})}
		/>
	{:else}
		<CardGrid gridGap="s" lg={250} class="mt-m">
			{@const tariffs = sortOn(Object.values(powerPrices.tariffs), 'create')}
			{#each tariffs as tariff, i}
				{#if tariffDropdowns[i] && tariffDropdowns[i].hasOwnProperty('showDropdown')}
					<DropdownMenu bind:show={tariffDropdowns[i].showDropdown}>
						<ListItem
							slot="trigger"
							class="width-full"
							viewType="fullColored"
							title={tariff.name}
							listItemBgColor={tariff?.bgColor
								? `--${tariff?.bgColor}-10`
								: '--color-green-10'}
							icon={tariff?.bgColor
								? `text-${tariff?.bgColor} fas fa-coins`
								: 'text-color-green fas fa-coins'}
							progress={{
								title: `${tariff.price} ${currency} / kWh`,
							}}
							rightIcon="fa-solid fa-ellipsis-vertical"
							on:click={() => {
								if (isNotDesktop) {
									showModalTariffsActions = true;
									editedTariff = { ...tariff };
									return;
								}

								toggleTariffDropdown(i);
							}}
						/>
						<MenuItemList
							size="m"
							icon="fas fa-pen"
							title={capFirstChar(
								$format('edit_tariff', {
									default: 'Edit Tariff',
								}).toLowerCase(),
							)}
							on:click={() => {
								editTariff(tariff);
								toggleTariffDropdown(i);
							}}
						/>
						<MenuItemList
							size="m"
							icon="fas fa-trash text-danger"
							title={$format('delete_tariff', { default: 'Delete tariff' })}
							on:click={() => {
								showDeleteTarrifsPrompt(tariff);
								toggleTariffDropdown(i);
							}}
						/>
					</DropdownMenu>
				{/if}
			{/each}
		</CardGrid>
	{/if}
	<Button
		on:click={addTariff}
		size="m"
		class="width-md-auto width-sm-full"
		disabled={Object.values(powerPrices.tariffs).length >= maxTariffs}
	>
		{$format('button_add_tariff', { default: 'Add tariff' })}
	</Button>
{/if}

{#if showModal}
	<AddEditTariffWizard
		bind:editedTariff
		bind:showModal
		bind:waitForResponse
		on:finish={save}
		on:delete={(e) => {
			showDeleteTarrifsPrompt(e.detail);
		}}
	/>
{/if}

{#if removeTariffModal}
	<Modal
		showModal={removeTariffModal}
		on:close={() => (removeTariffModal = false)}
		title={`${capFirstChar(
			$format('button_delete', { default: 'Delete' }),
		)} ${capFirstChar($format('title_tariff', { default: 'tariff' }))}?`}
	>
		<Container slot="content" padding="0">
			<div class="d-flex flex-direction-column align-items-center">
				<Icon size="xxl" icon="fa-light fa-trash" class="text-danger mb-xs" />
				<Text class="text-bold text-center mb-s" styleType="controls-large">
					{editedTariff.name}
				</Text>
				<Text class="width-full">
					{$format('on_delete_item_msg', {
						values: {
							device_name: editedTariff.name,
							type: $format('title_tariff', {
								default: 'tariff',
							}),
						},
						default: `Deleting ${$format('title_tariff', {
							default: 'tariff',
						}).toLowerCase()} ‘${editedTariff.name}’ will permanently remove it from your account.`,
					})}
				</Text>
			</div>
		</Container>

		<div class="d-flex justify-content-end" slot="footer">
			<Button
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
				responsiveSize={{
					sm: 'm',
				}}
				variant="secondary"
				on:click={() => (removeTariffModal = false)}
				>{$format('button_cancel', { default: 'Cancel' })}</Button
			>
			<Button
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
				variant="danger"
				responsiveSize={{
					sm: 'm',
				}}
				loading={waitForResponse}
				on:click={remove}
			>
				{capFirstChar($format('button_delete', { default: 'Delete' }))}
				{$format('title_tariff', { default: 'tariff' }).toLowerCase()}
			</Button>
		</div>
	</Modal>
{/if}

<Modal
	bind:showModal={showModalTariffsActions}
	title={$format('tariff_actions_heading', {
		values: { tariff_name: editedTariff?.name },
		default: '‘{tariff_name}’ actions',
	})}
	on:close={onCloseTariffActionsModal}
>
	<Container slot="content" padding="0">
		<CardGrid lg={250} gridGap="s" noPaddingBottom>
			<SelectCard
				cardBgColor={$showNewLayout ? 'color-1' : undefined}
				on:click={() => {
					editTariff(editedTariff);
					onCloseTariffActionsModal();
				}}
				class="width-full"
				hideAction
				icon="fas fa-pen"
				type="horizontal"
				title={capFirstChar($format('edit_tariff', { default: 'Edit Tariff' }).toLowerCase())}
			/>
			<SelectCard
				cardBgColor={$showNewLayout ? 'color-1' : undefined}
				on:click={() => {
					showDeleteTarrifsPrompt(editedTariff);
					onCloseTariffActionsModal();
				}}
				class="width-full"
				hideAction
				icon="text-danger fas fa-trash"
				type="horizontal"
				title={$format('delete_tariff', { default: 'Delete tariff' })}
			/>
		</CardGrid>
	</Container>
</Modal>
